import { useEffect } from "react";
import { ExternalLink } from "lucide-react";

const CLIENTHUB_ID = "eb5c28a4-366e-41f5-80a5-6040435b1b6a-5049854";
const FORM_URL =
  "https://clienthub.getjobber.com/client_hubs/eb5c28a4-366e-41f5-80a5-6040435b1b6a/public/work_request/embedded_work_request_form?form_id=5049854";
const OPEN_URL =
  "https://clienthub.getjobber.com/client_hubs/eb5c28a4-366e-41f5-80a5-6040435b1b6a/public/work_request/new?form_id=5049854";
const CSS_URL = "https://d3ey4dbjkt2f6s.cloudfront.net/assets/external/work_request_embed.css";
const SNIPPET_URL = "https://d3ey4dbjkt2f6s.cloudfront.net/assets/static_link/work_request_embed_snippet.js";
const SCRIPT_ID = "jobber-embed-script";

// Module-level guard: inject the Jobber snippet exactly once (StrictMode-safe).
let injected = false;

export const JobberEmbed = () => {
  useEffect(() => {
    if (!document.getElementById("jobber-embed-css")) {
      const link = document.createElement("link");
      link.id = "jobber-embed-css";
      link.rel = "stylesheet";
      link.media = "screen";
      link.href = CSS_URL;
      document.head.appendChild(link);
    }

    if (injected || document.getElementById(SCRIPT_ID)) return;
    injected = true;

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = SNIPPET_URL;
    script.setAttribute("clienthub_id", CLIENTHUB_ID);
    script.setAttribute("form_url", FORM_URL);
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div>
      <div className="relative min-h-[440px]">
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-navy/40 pointer-events-none">
          <div className="h-8 w-8 rounded-full border-2 border-navy/20 border-t-gold animate-spin" />
          <span className="font-primary uppercase text-xs tracking-widest">Loading request form…</span>
        </div>
        <div id={CLIENTHUB_ID} data-testid="jobber-embed" className="relative" />
      </div>

      <div className="mt-4 pt-4 border-t border-navy/10 text-center">
        <a
          href={OPEN_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="jobber-open-fallback"
          className="inline-flex items-center gap-1.5 font-primary uppercase text-xs tracking-widest text-navy/60 hover:text-navy transition-colors"
        >
          Form not loading? Open it in a new window <ExternalLink size={13} />
        </a>
      </div>
    </div>
  );
};
